import EventBus from 'diagram-js/lib/core/EventBus';
import {ModelingUtil} from "@ispm/shared/bpmn-io/modeling-util";
import {connection} from '@ispm-shared/modules/bpmn';
import {constants} from "@ispm-client/modules/bpmn-modeler/constants/constants";
import {NodeType} from "@ispm/shared/bpmn-io/node-type";

export class ContextPadCreateBehavior {
  private readonly NEIGHBOURHOOD_NODE_ACTIONS_NUM = 3;
  private readonly TREATMENT_NODE_ACTIONS_NUM = 2;
  private readonly HEAD_NODE_ACTIONS_NUM = 5;
  private readonly DEFAULT_NODE_ACTIONS_NUM = 8;


  constructor(private eventBus: EventBus, private elementRegistry) {
    eventBus.on('contextPad.open', 500, (e) => {
      const element = e.current.element || e.current.target;
      const pad = e.current.pad;
      let topVal, leftVal;
      if (ModelingUtil.getElementType(element) === connection) {
        topVal = constants.CONNECTION_ICONS_OVERLAYS.top;
        if (!ModelingUtil.connectionIsStraight(element)) {
          leftVal = element.waypoints[element.waypoints.length - 2].x ;
          topVal = element.waypoints[element.waypoints.length - 2].y +  constants.CONNECTION_ICONS_OVERLAYS.space;

        } else {
          const leftNodeX = element.source.x + element.width;
          const getBusinessObject = ModelingUtil.getElementBO(element);
          leftVal = (!!getBusinessObject && !!getBusinessObject.sourceRef && getBusinessObject.sourceRef.id.startsWith('Gateway')) ?
            element.waypoints[element.waypoints.length - 2].x : leftNodeX + Math.abs(Math.round((element.target.x - leftNodeX) / 2) ) + constants.OVERLAY_ICON.width;
          topVal = element.waypoints[0].y + constants.CONNECTION_ICONS_OVERLAYS.space;
        }
        pad.htmlContainer.style.left = `${leftVal}px`;

      } else {
        let numOfActions;
        const nodeType = ModelingUtil.getNodeType(element);
        switch (nodeType) {
          case  NodeType.neighborhood_entry:
            numOfActions = this.NEIGHBOURHOOD_NODE_ACTIONS_NUM;
            break;
          case  NodeType.treatment:
            numOfActions = this.TREATMENT_NODE_ACTIONS_NUM;
            break;
          case  NodeType.head:
            numOfActions = this.HEAD_NODE_ACTIONS_NUM;
            break;
          default: {
            numOfActions = this.DEFAULT_NODE_ACTIONS_NUM;
            break;
          }
        }
        if(nodeType === undefined) {
          pad.htmlContainer.style.visibility = "hidden";
        }

        const actionsElemHeight = numOfActions * constants.OVERLAY_ICON.height;
        let newElement;
        if(element && Array.isArray(element)) {
          newElement = element[0];
        } else {
          newElement = element;
        }
        topVal = nodeType === NodeType.treatment ?  newElement.y :  newElement.y - Math.round(actionsElemHeight/2);
      }
      pad.htmlContainer.style.top = `${topVal}px`;
      pad.position.top = topVal;
    });
  }
}
